import React, {useState, useEffect} from 'react'
import '../App.css'
import Button from './Button'
import useProfileStore from '../store/profileStore'
import useDragLineStore from '../store/dragLineStore'

function Toolbar() {
  const setDragMode = useDragLineStore(state => state.setDragMode);

  const selectedPts = useProfileStore(state => state.selectedPts)
  const getState = useProfileStore(state => state.getState)
  const undo = useProfileStore(state => state.undo)
  const redo = useProfileStore(state => state.redo)
  const clear = useProfileStore(state => state.clear)
  // const prevStates = useProfileStore(state => state.prevStates)
  // const futureStates = useProfileStore(state => state.futureStates)

  const [depressedStyles, setDepressedStyles] = useState('')
  const [undoStyles, setUndoStyles] = useState('disabled')
  const [redoStyles, setRedoStyles] = useState('disabled')
  const [saveStyles, setSaveStyles] = useState('disabled')

  const handleUndo = () => {
    undo()
  }

  const handleRedo = () => {
    redo()
  }

  const handleSave = () => {

  }

  const handleDraw = () => {
    setDragMode(depressedStyles? false:true  )
    setDepressedStyles(depressedStyles? '':'depressed')
  }

  const handleClearAll = () => {
    setDragMode(false)
    clear()
    window.location.reload();
  }

  useEffect(() => {
    if(getState){
      if(getState().prevStates.length>1){
        setUndoStyles('')
      }else{
        setUndoStyles('disabled')
      }

      if(getState().futureStates.length>0){
        setRedoStyles('')
      }else{
        setRedoStyles('disabled')
      }
    }
  },[selectedPts])


  return (
    <div className = "toolbar">
      <Button btnText="Draw" onHandle={handleDraw} styles={depressedStyles}/>
      <Button btnText="Save" onHandle={handleSave} styles={saveStyles}/>
      <Button btnText="Undo" onHandle={handleUndo} styles={undoStyles}/>
      <Button btnText="Redo" onHandle={handleRedo} styles={redoStyles}/>
      <Button btnText="ClearAll" onHandle={handleClearAll} />
    </div>
  )
}

export default Toolbar
